import { isUndefined } from 'lodash';

import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { useBillableUsersCount } from '~/swr-hooks/members/useBillableUsersCount';
import { useWorkspaceTotals } from './useWorkspaceTotals';

/**
 * This hook returns a boolean indicating if the max number of members has been reached in the workspace.
 * It returns undefined if the underlying allMembers data is undefined though (hasn't been loaded yet.)
 */
export function useReachedMemberLimit() {
  const { data: subscription } = useSubscriptionContext();
  const { data: totals } = useWorkspaceTotals();
  const { totalBillableSeats } = useBillableUsersCount();

  const UNLIMITED_MEMBERS = null;

  return {
    reachedMemberLimit:
      isUndefined(totals) || isUndefined(subscription) || isUndefined(totalBillableSeats)
        ? undefined
        : subscription.maxMembers === UNLIMITED_MEMBERS
          ? false
          : totalBillableSeats >= subscription.maxMembers,
  };
}
